import {multiroomRoomOptionsContainer} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {useCallback, useEffect, useRef, useState} from 'react';
import {WrapperDiv, WrapperSection} from '../../../../DetailsPage.styles';
import ComboHeading from './ComboHeading/ComboHeading';

const CustomCombo = () => {
  return (
    <div id={multiroomRoomOptionsContainer}>
      <WrapperSection>
        <WrapperDiv>
          <ComboHeading />
        </WrapperDiv>
      </WrapperSection>
    </div>
  );
};
export default CustomCombo;
